import { FieldBase } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/FieldBase';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import {
  StundenBewertung,
  stundenBewertung,
} from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/stundenBewertung';
import { RadioGroup, RadioGroupItem } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

type StundenbewertungToggleProps = {
  onlyFesteStundenbewertung: boolean;
};

export function StundenbewertungToggle({
  onlyFesteStundenbewertung,
}: StundenbewertungToggleProps) {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();

  return (
    <form.AppField
      name="abwesenheiten.allgemein.stundenBewertung"
      defaultValue={
        onlyFesteStundenbewertung ? stundenBewertung.fest : undefined
      }
      listeners={{
        onChange: () => {
          ctx.resetDependentFields('abwesenheiten.allgemein.stundenBewertung');
        },
      }}>
      {(field) => (
        <FieldBase>
          <RadioGroup
            value={field.state.value}
            onValueChange={(e) => field.handleChange(e as StundenBewertung)}
            className="flex flex-row">
            <RadioGroupItem
              variant="card"
              layout="horizontal"

              label={t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.options.fest',
              )}
              value={stundenBewertung.fest}
              className="w-full"
            />
            <RadioGroupItem
              variant="card"
              layout="horizontal"
              label={t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.options.dynamisch',
              )}
              value={stundenBewertung.dynamisch}
              className="w-full"
            />
          </RadioGroup>
        </FieldBase>
      )}
    </form.AppField>
  );
}
